const styles = (theme) => ({
    table: {
        margin: '0 0 30px 0',
    },
    tableRow: {
        verticalAlign: 'middle',
    },
    headTableCell: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
    },
    headTableCellDark: {
        backgroundColor: theme.palette.primary.dark,
        color: theme.palette.common.white,
    },
    centerProgress: {
        textAlign: 'center',
    },
    requestInfo: {
        marginBottom: '30px',
    },
    positionRelative: {
        position: 'relative',
    },
    loadingUser: {
        position: 'absolute',
        top: '35px',
        right: '45px',
    },
    approved: {
        color: theme.palette.info.dark,
    },
    disapproved: {
        color: theme.palette.error.dark,
    },
});

export default styles;
